import { deleteCharacterCommand } from '#pplx/frontend/composer-sdk/internal/input/commands/deleteCharacterCommand.js';
import { dropCommand } from '#pplx/frontend/composer-sdk/internal/input/commands/dropCommand.js';
import { pasteCommand } from '#pplx/frontend/composer-sdk/internal/input/commands/pasteCommand.js';
import { useEffect } from 'react';
export function useComposerInputCommands({ editor }) {
    useEffect(() => {
        if (!editor)
            return;
        const deleteCharacterCommandCleanup = deleteCharacterCommand(editor);
        const dropCommandCleanup = dropCommand(editor);
        const pasteCommandCleanup = pasteCommand({ editor });
        return () => {
            deleteCharacterCommandCleanup();
            dropCommandCleanup();
            pasteCommandCleanup();
        };
    }, [editor]);
}
//# sourceMappingURL=useComposerInputCommands.js.map